import { computed } from 'vue';
import { useIdentityStore } from '@/stores/identity';
import { usePdfStore } from '@/stores/pdf';
import { useSocketStore } from '@/stores/socket';
import { useTrackingStore } from '@/stores/tracking';
import { originForReport } from '@/config';
import { useDrawer } from '@dashhudson/dashing-ui/drawer';
import { useRoute, useRouter } from 'vue-router';

export function usePdfDownload() {
  const identityStore = useIdentityStore();
  const pdfStore = usePdfStore();
  const trackingStore = useTrackingStore();
  const socketStore = useSocketStore();

  const route = useRoute();
  const router = useRouter();

  const isPdfReport = computed(() => route.meta.report);

  function generateReportUrl() {
    const currentPath = route.path;

    const resolvedRoute = router.resolve({
      path: `${currentPath}/report`,
      query: route.query,
    });
    const url = `${originForReport()}${resolvedRoute.href}`;

    return url;
  }

  const generatePdf = ({ url, filename, type, width, height, scale, trackingData = {} }) => {
    pdfStore.getPdfV2({
      filename,
      notificationSocketId: socketStore.id,
      idleMaxInflightRequest: 2,
      idleTimeout: 20,
      scale,
      width,
      height,
      notificationMeta: JSON.stringify({ type }),
      url: url ?? generateReportUrl(),
    });

    trackingStore.track('Report Downloaded', {
      type,
      filename,
      format: 'PDF',
      ...trackingData,
    });
  };

  const downloadPagePdf = (params) => {
    generatePdf(params);
  };

  const downloadDrawerPdf = ({ drawerName, drawerProps = {}, ...params }) => {
    const { generateStateKey } = useDrawer();
    const drawerStateKey = generateStateKey(drawerName, drawerProps);

    const query = {
      ...route.query,
      ...(route.query.d ? {} : { d: drawerStateKey }),
    };

    const resolvedRoute = router.resolve({
      path: `/${identityStore.currentBrand.label}/d/report`,
      query,
    });
    const url = `${originForReport()}${resolvedRoute.href}`;

    generatePdf({
      ...params,
      scale: 0.8,
      url,
      trackingData: {
        ...params.trackingData,
        drawerName,
        drawerProps,
      },
    });
  };

  return {
    isPdfReport,
    downloadPagePdf,
    downloadDrawerPdf,
  };
}
